import React from "react";
import {
  FormFieldInputType,
  FormFieldModel,
} from "~/PageCreatorPage/Models/PageCreatorPage";
import FormCheckbox from "./FormCheckbox";
import FormCheckboxGroup from "./FormCheckboxGroup";
import FormDropdown from "./FormDropdown";
import FormInput from "./FormInput";
import FormAddress from "./FormAddress";
import FormTextarea from "./FormTextarea";
import FieldWrapper from "./FieldWrapper";

interface Props {
  field: FormFieldModel;
  formTextColor: string;
  errorMessage?: string;
  setFormValue: (key: string, value: string | number | boolean) => void;
}

const FormFieldInput = ({
  field,
  formTextColor,
  errorMessage,
  setFormValue,
}: Props): JSX.Element => {
  const displayInputByType = () => {
    switch (field.fieldType) {
      case FormFieldInputType.Custom:
      case FormFieldInputType.EmailAddress:
      case FormFieldInputType.PhoneNumber:
        return (
          <FormInput
            label={field.label}
            inputName={field.formFieldId.toString()}
            errorMessage={errorMessage}
            setFormValue={setFormValue}
          />
        );
      case FormFieldInputType.Address:
        return (
          <FormAddress
            label={field.label}
            inputName={field.formFieldId.toString()}
            errorMessage={errorMessage}
            setFormValue={setFormValue}
          />
        );
      case FormFieldInputType.Textarea:
        return (
          <FormTextarea
            label={field.label}
            inputName={field.formFieldId.toString()}
            errorMessage={errorMessage}
            setFormValue={setFormValue}
          />
        );
      case FormFieldInputType.Dropdown:
        return (
          <FormDropdown
            label={field.label}
            options={field.options}
            inputName={field.formFieldId.toString()}
            errorMessage={errorMessage}
            setFormValue={setFormValue}
          />
        );
      case FormFieldInputType.TermsAndCondition:
        return (
          <FormCheckbox
            {...field}
            formTextColor={formTextColor}
            inputName={field.formFieldId.toString()}
            errorMessage={errorMessage}
            setFormValue={setFormValue}
          />
        );
      case FormFieldInputType.CheckboxGroup:
        return (
          <FormCheckboxGroup
            {...field}
            label={field.label}
            formTextColor={formTextColor}
            options={field.options}
            inputName={field.formFieldId.toString()}
            errorMessage={errorMessage}
            setFormValue={setFormValue}
          />
        );
      default:
        return <></>;
    }
  };

  switch (field.fieldType) {
    case FormFieldInputType.Custom:
    case FormFieldInputType.EmailAddress:
    case FormFieldInputType.PhoneNumber:
    case FormFieldInputType.Address:
    case FormFieldInputType.Textarea:
    case FormFieldInputType.Dropdown:
      return (
        <FieldWrapper
          label={field.label}
          fieldName={field.formFieldId.toString()}
          isRequired={field.isRequired}
          formTextColor={formTextColor}
          errorMessage={errorMessage}
        >
          {displayInputByType()}
        </FieldWrapper>
      );
    case FormFieldInputType.TermsAndCondition:
    case FormFieldInputType.CheckboxGroup:
      return displayInputByType();
    default:
      return <></>;
  }
};

export default FormFieldInput;
